import { getFileExtension, getFileTypeLabel } from '@/lib/fileType';

import { OfficeFileIcon } from '@/components/icons/OfficeFileIcon';

export const FILE_CARD_HOVER_CLASS =
    'hover:bg-[color-mix(in_srgb,hsl(var(--background))_70%,hsl(var(--muted)))]';

interface FileCardContentProps {
    name: string;
}

/**
 * Icon + filename + type-label block shared by every file attachment card
 * (the sent-message file card, the uploads panel, etc.). Callers own the
 * surrounding interactive element (link, clickable div) and any action
 * button/icon placed alongside or on top of this.
 */
export function FileCardContent({ name }: FileCardContentProps) {
    const ext = getFileExtension(name);
    const typeLabel = getFileTypeLabel(ext);

    return (
        <div className="flex gap-4 min-w-0">
            <div className="flex justify-center items-center bg-background border border-border rounded-lg w-10 h-10 overflow-hidden shrink-0">
                <OfficeFileIcon extension={ext} size={24} />
            </div>

            <div className="flex flex-col min-w-0">
                <span
                    className="font-medium text-foreground text-sm truncate"
                    title={name}
                >
                    {name}
                </span>
                <span className="text-muted-foreground text-sm truncate">
                    {typeLabel}
                    {ext ? ` - ${ext.toUpperCase()}` : ''}
                </span>
            </div>
        </div>
    );
}
